/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Notification_Agent_Run_SucceededInputs */



/**
* | output |
* | --- |
* | "{name} finished a run" |
*
* @param {Notification_Agent_Run_SucceededInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notification_agent_run_succeeded = /** @type {((inputs: Notification_Agent_Run_SucceededInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Agent_Run_SucceededInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} hat einen Lauf abgeschlossen.`)
	return /** @type {LocalizedString} */ (`${i?.name} finished a run`)
});